module.exports = __webpack_public_path__ + "static/media/20240811_113509.84f9af6a.jpg";